import { useHistory } from 'react-router';

import { HomeroomHistory } from './HomeroomHistory';

export function useHrHistory() {
  return useHistory() as HomeroomHistory;
}